import { render, staticRenderFns } from "./BookForm.vue?vue&type=template&id=71f27839"
import script from "./BookForm.vue?vue&type=script&lang=js"
export * from "./BookForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports